/** Rutas de la aplicación como constantes para evitar strings mágicos. */
export const ROUTES = {
  home:     '/',
  capture:  '/captura',
  results:  '/finalizado',
} as const;
